export type PersonalDataConsentErrorCause =
  | "cancelled"
  | "network_fail"
  | "timeout"
  | "unknown";

export class PersonalDataConsentError extends Error {
  public cause: PersonalDataConsentErrorCause;

  constructor(message: string, cause: PersonalDataConsentErrorCause) {
    super(message);
    this.name = "PersonalDataConsentError";
    this.cause = cause;
  }
}

export function isCancelledPersonalDataConsentError(
  error: unknown,
): error is PersonalDataConsentError {
  return (
    error instanceof PersonalDataConsentError && error.cause === "cancelled"
  );
}
